import { fetchApi } from '@/api'
const AdminAllRoles = (context) => {
  let url = 'admin/roles'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ADMIN_ROLES_ALL', response)
    })
    .catch((error) => {
      console.log(error)
    })
}

const AdminRoleData = (context, param) => {
  console.log('miparam', param.id)
  let url = 'admin/roles/' + param.id + '/edit'
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ADMIN_ROLES_ALL', response)
    })
    .catch((error) => {})
}

const AdminRoleUpdate = (context, param) => {
  let json = JSON.stringify(param)
  let url = 'admin/roles/' + param.id
  return fetchApi(url, json, 'PUT')
    .then((response) => {
      context.commit('ADMIN_ROLES_ALL', response)
    })
    .catch((error) => {})
}

const AdminRoleCreate = (context, param) => {
  let json = JSON.stringify(param)
  let url = 'admin/roles'
  return fetchApi(url, json, 'POST')
    .then((response) => {
      context.commit('ADMIN_ROLES_ALL', response)
    })
    .catch((error) => {})
}

const AdminRoleDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/roles/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('ADMIN_ROLES_ALL', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error)
    })
}

export default {
  AdminAllRoles,
  AdminRoleData,
  AdminRoleUpdate,
  AdminRoleCreate,
  AdminRoleDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/roles/actions.js